import { getFeatureFlag } from './shell-helpers'

export const getContactCenterAgentBaseUrl = () => {
  const agentVersion = getFeatureFlag('cc-agent-version', 'latest')
  return `/experiences/cc-agent/${agentVersion}`
}
